export enum AuthPref {
	PASSWORD_MINIMUM_LENGTH = 'sys.minimumPasswordLength',
	PASSWORD_PATTERN = 'sys.passwordPattern',
}

export enum AuthPasswordPatternType {
	LOWERCASE_LETTERS = 'L',
	NUMBER = 'N',
	SPECIAL_CHARACTERS = 'S',
	UPPERCASE_LETTERS = 'U',
}
